export const menu = {
  dashboard: 'ダッシュボード',
  revenue: '売上管理',
  user: 'ユーザーリスト',
};
